// Module
var code = "<page-header title=\"'服务列表'\" breadcrumbs=\"['服务']\" reload=\"true\"> </page-header>\n\n<docker-services-datatable\n  dataset=\"services\"\n  title-icon=\"shuffle\"\n  on-refresh=\"(getServices)\"\n  is-add-action-visible=\"true\"\n  is-stack-column-visible=\"true\"\n  table-key=\"'services'\"\n></docker-services-datatable>\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/services/services.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;